import { create } from 'zustand'
import { logger } from '@/lib/services/logger-service'
import { Database } from '@/types/supabase'

// Simplified Child type with only the essential fields
export interface Child {
  id: string;
  name: string;
  date_of_birth: string;
  caregiver_id?: string; // Kept for backward compatibility
}

interface ChildStore {
  children: Child[]
  selectedChild: Child | null
  loading: boolean
  error: string | null

  // Actions
  setChildren: (children: Child[]) => void
  setSelectedChild: (child: Child | null) => void
  setLoading: (loading: boolean) => void
  setError: (error: string | null) => void
  
  // Computed
  getChildById: (id: string) => Child | undefined
}

export const useChildStore = create<ChildStore>((set, get) => ({
  children: [],
  selectedChild: null,
  loading: false,
  error: null,

  setChildren: (children) => {
    logger.debug('Setting children in store', { count: children.length })
    set({ children })
  },

  setSelectedChild: (child) => {
    logger.debug('Setting selected child', { childId: child?.id })
    set({ selectedChild: child })

    // Log analytics
    if (child) {
      logger.debug('Child selected', {
        childId: child.id,
        childName: child.name
      })
    }
  },

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),

  getChildById: (id) => get().children.find(child => child.id === id)
}))